import MagneticTravelRtPanel from "./MagneticTravelRtPanel";

/**
 * 迅洁(RS)：华奋达磁轴在选键后展示快速触发行程；机械轴/星闪无额外面板。
 */
const rs = (props: any) => {
  const {
    checkData,
    getAfterChangeData,
    isMagnetic = false,
    keyboardType,
  } = props;
  if (!isMagnetic) return null;
  return (
    <MagneticTravelRtPanel
      checkData={checkData}
      getAfterChangeData={getAfterChangeData}
      showRt={false}
      keyboardType={keyboardType}
    />
  );
};

export default rs;
